import { motion } from "framer-motion";
import IMG, { isGeneratedRender } from "@/lib/images";
import RenderedBadge from "@/components/RenderedBadge";

const ITEMS = [
  { src: IMG.jadau, label: "Jadau Choker", category: "Bridal" , span: "md:col-span-2 md:row-span-2"},
  { src: IMG.polki, label: "Polki Layered Set", category: "Couture", span: "" },
  { src: IMG.meenakari, label: "Meenakari Bangle", category: "Enamel", span: "" },
  { src: IMG.temple, label: "Temple Necklace", category: "South Indian", span: "md:col-span-2" },
  { src: IMG.bridal, label: "Rajwadi Bridal", category: "Heritage", span: "" },
  { src: IMG.filigree, label: "Tarakashi Pendant", category: "Fine Craft", span: "" },
  { src: IMG.ring, label: "Solitaire Ring", category: "Modern Fusion", span: "" },
  { src: IMG.bangle, label: "Gold Bangle", category: "Daily Luxury", span: "" },
  { src: IMG.choker, label: "Diamond Choker", category: "Statement", span: "md:col-span-2" },
];

export default function Showcase() {
  return (
    <section id="showcase" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="flex flex-col md:flex-row md:items-end justify-between gap-6"
        >
          <div>
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">Showcase</p>
            <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] text-white max-w-3xl">
              A render gallery — <span className="italic gold-gradient-text">crafted by AI</span>, judged by jewellers.
            </h2>
          </div>
          <p className="text-white/55 text-sm md:text-base max-w-sm">
            A glimpse into what teams produced in their first week with Facetra.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-4">
          {ITEMS.map((it, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, delay: i * 0.04 }}
              data-testid={`showcase-tile-${i}`}
              className={`relative overflow-hidden rounded-2xl border border-white/10 group ${it.span}`}
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-[1500ms] ease-out group-hover:scale-110"
                style={{ backgroundImage: `url(${it.src})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-[#0B0B0B]/20 to-transparent" />
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[#D4AF37]/5" />
              {isGeneratedRender(it.src) && (
                <RenderedBadge className="absolute top-3 right-3" compact />
              )}              <figcaption className="absolute bottom-0 inset-x-0 p-4 flex items-end justify-between">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.22em] text-[#D4AF37]">{it.category}</div>
                  <div className="font-display text-white text-base md:text-lg mt-1">{it.label}</div>
                </div>
                <span className="opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all text-white/70 text-sm">
                  →
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
